import type * as lazyIndex from "./lazyIndex";
import { createLazyComponent, LazyModule, registerLazyOrchestrator } from "owa-bundling";
import { onShowToast } from "owa-nova-actions";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "OwaActionResultToaster" */ "./lazyIndex"), { name: "OwaActionResultToaster" });

registerLazyOrchestrator(onShowToast, lazyModule, m => m.showActionResultToast);

export const ActionResultToasterAsync: typeof lazyIndex.ActionResultToasterWrapper = createLazyComponent(lazyModule, m => m.ActionResultToasterWrapper);
